export default __webpack_public_path__ + "static/media/manager_user.3afba282.svg";